import { getValue } from '@kundinos/nanostores';

import * as TextileFiltrator from '@Stores/TextileFiltrator';
import * as OrderFabrics from '@Stores/OrderFabrics';

function filterCollections() {
  let collections = [...getValue(OrderFabrics.orderFabricsStore).allCollections];
  const filters = getValue(TextileFiltrator.getStores().filtratorStore);

  // Фильтруем по цвету
  if (filters.parameters['40']) {
    const colors = filters.parameters['40'].default as number[];

    collections = collections.map((collection) => {
      if (!colors.length) return collection;

      return {
        ...collection,
        fabrics: collection.fabrics.filter((fabric) => colors.includes(fabric.tags.colorId)),
      };
    });
  }

  // Фильтруем по коллекции
  if (filters.parameters['20']) {
    const collectionsParam = filters.parameters['20'].default as number[];

    collections = collections.map((collection) => {
      if (!collectionsParam.length) return collection;

      return {
        ...collection,
        fabrics: collection.fabrics.filter((fabric) => {
          return collectionsParam.includes(fabric.tags.collectionId);
        }),
      };
    });
  }

  // Фильтруем по типу ткани
  if (filters.parameters['50']) {
    const materialsParam = filters.parameters['50'].default as number[];

    collections = collections.map((collection) => {
      if (!materialsParam.length) return collection;

      return {
        ...collection,
        fabrics: collection.fabrics.filter((fabric) => {
          return materialsParam.includes(fabric.tags.materialId);
        }),
      };
    });
  }

  // Оставляем только те коллекции, в которых есть ткани и сортируем
  collections = collections.filter((collection) => collection.fabrics.length > 0);

  return collections;
}

export default filterCollections;
